import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { EMPTY_PROTOCOL_HEADER_FOOTER } from '../../utils/protocolExportHeaderFooter';
import { PDF_FONT_REGULAR, sanitizePdfPt } from '../../utils/pdfFontSetup';
import { PDF_HEADER_RESERVED_PT } from '../../utils/protocolPdfLayout';
import { renderHybridPdfText } from '../../utils/renderHybridPdfText';

/**
 * Word-style running header + "Confidential" footer (Draft 1.0 §4.6).
 * Page numbers are stamped after render via pdf-lib (see stampProtocolPdfPageNumbers)
 * because react-pdf Text `render` page numbers are unreliable on long multi-Page docs.
 */
const ProtocolPdfHeaderFooter = ({
  info = EMPTY_PROTOCOL_HEADER_FOOTER,
  fontSize = 10,
  horizontalMargin = 72,
  showHeader = true,
  showFooter = true,
}) => {
  const hfStyle = {
    fontSize: sanitizePdfPt(fontSize, 10),
    fontFamily: PDF_FONT_REGULAR,
    color: '#000000',
    lineHeight: 1,
  };

  return (
    <>
      {showHeader && (
        <View
          fixed
          style={{
            position: 'absolute',
            top: 22,
            left: horizontalMargin,
            right: horizontalMargin,
            height: PDF_HEADER_RESERVED_PT,
          }}
        >
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={[hfStyle, { maxWidth: '48%', textAlign: 'left' }]}>
              {renderHybridPdfText(info.investigationalProductNames) || ' '}
            </Text>
            <Text style={[hfStyle, { maxWidth: '48%', textAlign: 'right' }]}>
              {renderHybridPdfText(info.sponsorName) || ' '}
            </Text>
          </View>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 4 }}>
            <Text style={[hfStyle, { maxWidth: '48%', textAlign: 'left' }]}>
              {renderHybridPdfText(info.protocolNumber) || ' '}
            </Text>
            <Text style={[hfStyle, { maxWidth: '48%', textAlign: 'right' }]}>
              {renderHybridPdfText(info.versionDate) || ' '}
            </Text>
          </View>
        </View>
      )}

      {showFooter && (
        <Text
          fixed
          style={{
            ...hfStyle,
            position: 'absolute',
            bottom: 28,
            left: 0,
            right: 0,
            paddingLeft: horizontalMargin,
            textAlign: 'left',
          }}
        >
          Confidential
        </Text>
      )}
    </>
  );
};

export default ProtocolPdfHeaderFooter;
